/** @flow */

import type { State } from "@store/reducers";
import type {
  ReportingModalsState,
  AddEditReportModalType,
  SaveReportModalType,
} from "@modules/reporting/reducer/modals/types";

export const getReportModals = (state: State): ReportingModalsState => state.reporting.modals;

export const getAddEditReportModal = (state: Object): AddEditReportModalType =>
  getReportModals(state).addEditReportModal;

export const getSaveReportModal = (state: Object): SaveReportModalType =>
  getReportModals(state).saveReportModal;

export const getScheduleReportSettingsModal = (state: Object) => {
  return state.reporting.modals.scheduleReportSettingsModal;
};
export const getScheduleReportSettingsModalData = (state: Object) => {
  return state.reporting.modals.scheduleReportSettingsModal.data;
};
export const getCancelTaskModal = (state: Object) => {
  return state.reporting.modals.cancelTaskModal;
};
export const getHistoricReportModal = (state: Object) => {
  return state.reporting.modals.historicReportModal;
};

export const getMiLogModal = (state: Object) => {
  return state.reporting.modals.miLogModal;
};
export const getMiShareModal = (state: Object) => {
  return state.reporting.modals.miShareModal;
};

export const isLoading = (state: Object) => {
  return state.reporting.modals.isLoading > 0;
};
